// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Orders, Orders as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import type { HasTokenAssignment, LaneAssigneeType } from "@lg/shared";

class $CustomerOrderProcess {
    static get __type(): 'Orders.CustomerOrderProcess' {
        return 'Orders.CustomerOrderProcess'
    }

    get __type(): 'Orders.CustomerOrderProcess' {
        return 'Orders.CustomerOrderProcess'
    }

    static async start(inputData: $CustomerOrderProcess.ProcessInputData, startBy?: 'normal') {
        const instanceId = await ExecutionService.executeMethodAndReturnData<string>('Process', 'Orders', 'CustomerOrderProcess', this, 'start', [inputData, startBy])
        return instanceId
    }

    static async startAndGetFirstUserTaskToken(inputData: $CustomerOrderProcess.ProcessInputData, startBy?: 'normal', taskTimeoutMs?: number, taskDebounceMs?: number) {
        const obj = await ExecutionService.executeMethodAndReturnData<{ instanceId: string, taskToken: Sys.Types.UserTaskToken }>('Process', 'Orders', 'CustomerOrderProcess', this, 'startAndGetFirstUserTaskToken', [inputData, startBy, taskTimeoutMs, taskDebounceMs])
        if (obj?.taskToken) obj.taskToken = new Sys.Types.UserTaskToken(obj.taskToken)
        return obj
    }

    static async startAndNavigateToFirstUserTask(inputData: $CustomerOrderProcess.ProcessInputData, isNewWindow: boolean | string, startBy?: 'normal', failIfNoUserTask: boolean = true, taskTimeoutMs?: number, taskDebounceMs?: number) {
        const obj = await this.startAndGetFirstUserTaskToken(inputData, startBy, taskTimeoutMs, taskDebounceMs)
        if (obj.taskToken) {
            obj.taskToken = new Sys.Types.UserTaskToken(obj.taskToken)
            await Sys.Process.navigateToTask(obj.taskToken, isNewWindow)
        } else {
            if (failIfNoUserTask) throw new Error(`No user task found for process instance ${obj.instanceId}`)
        }

        return obj
    }
}

namespace $CustomerOrderProcess {
    export interface ProcessInputData {
        requestId: This.CustomerRequest.Id;
        mail: Sys.Types.Mail;
        mailTimestamp: number;
    }
}

export { $CustomerOrderProcess as CustomerOrderProcess };
